export default function PrivacyPolicy() {
	return (
		<div className="font-sans leading-relaxed p-6 max-w-4xl mx-auto">
			<header className="text-center mb-8">
				<h1 className="text-4xl font-bold text-gray-800">Privacy Policy</h1>
				<p className="text-sm text-gray-500 mt-2">
					<strong>Effective Date:</strong> 22 Mar 2025
				</p>
			</header>
			
			<section>
				<p className="text-gray-700 mb-6">
					AudioDub.ai ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy
					explains how we
					collect, use, and safeguard your information when you use our website and services.
				</p>
				
				<h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Information We Collect</h2>
				<p className="text-gray-700 mb-4">
					When you use <strong>AudioDub.ai</strong>, we may collect the following types of information:
				</p>
				<ul className="list-disc pl-5 text-gray-700 space-y-2">
					<li><strong>Account Information:</strong> Name, email address, and other details you provide when
						creating an account.
					</li>
					<li><strong>User-Generated Content:</strong> Audio files, text inputs, or other content uploaded for
						processing.
					</li>
					<li><strong>Payment Information:</strong> If you make a purchase, our third-party payment processor
						may collect billing details.
					</li>
					<li><strong>Technical Data:</strong> IP address, browser type, and device information for security
						and service optimization.
					</li>
				</ul>
				
				<h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. How We Use Your Information</h2>
				<p className="text-gray-700 mb-4">
					We use your data for the following purposes:
				</p>
				<ul className="list-disc pl-5 text-gray-700 space-y-2">
					<li>Providing and improving our AI-powered services.</li>
					<li>Processing transactions and managing accounts.</li>
					<li>Offering customer support and responding to inquiries.</li>
					<li>Ensuring security, preventing fraud, and complying with legal obligations.</li>
				</ul>
				
				<h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Data Sharing & Third Parties</h2>
				<p className="text-gray-700 mb-4">
					We do not sell your personal information. However, we may share data with trusted third parties,
					including:
				</p>
				<ul className="list-disc pl-5 text-gray-700 space-y-2">
					<li><strong>Payment processors</strong> for secure transactions.</li>
					<li><strong>Cloud service providers</strong> for storage and processing.</li>
					<li><strong>Legal authorities</strong> if required to comply with applicable laws.</li>
				</ul>
				
				<h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. Data Security & Retention</h2>
				<p className="text-gray-700 mb-4">
					We implement security measures to protect your data from unauthorized access. Your information is
					stored securely and
					retained only as long as necessary for service functionality and compliance.
				</p>
				
				<h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. Your Rights & Choices</h2>
				<p className="text-gray-700 mb-4">
					You have the right to:
				</p>
				<ul className="list-disc pl-5 text-gray-700 space-y-2">
					<li>Request access to your data.</li>
					<li>Request deletion of your account and associated information.</li>
					<li>Contact us for privacy-related inquiries at <strong>contact@audiodub.ai</strong>.</li>
				</ul>
				
				<h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. Cookies & Tracking</h2>
				<p className="text-gray-700 mb-4">
					We do <strong>not</strong> use tracking technologies or third-party cookies for analytics or
					advertising.
				</p>
				
				<h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. Children's Privacy</h2>
				<p className="text-gray-700 mb-4">
					Protecting the privacy of children is especially important. For that reason, we do not collect or
					maintain
					information at our Site from those we know are under 13 years of age, and our Site is a general
					audience site not
					intended for users under the age of 13.
				</p>
				
				<h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8. Policy Updates</h2>
				<p className="text-gray-700 mb-4">
					We may update this Privacy Policy periodically. Any changes will be posted on this page, and
					significant updates
					may be communicated via email.
				</p>
				
				<p className="text-gray-700 mb-4">
					For any questions or concerns, contact us at <strong>contact@audiodub.ai</strong>.
				</p>
			</section>
		</div>
	);
}
